import { render, staticRenderFns } from "./payment-success.component.vue?vue&type=template&id=68f56e05&scoped=true"
import script from "./payment-success.component.ts?vue&type=script&lang=ts&external"
export * from "./payment-success.component.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-success.component.vue?vue&type=style&index=0&id=68f56e05&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f56e05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f56e05')) {
      api.createRecord('68f56e05', component.options)
    } else {
      api.reload('68f56e05', component.options)
    }
    module.hot.accept("./payment-success.component.vue?vue&type=template&id=68f56e05&scoped=true", function () {
      api.rerender('68f56e05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/checkout/payment-success.component.vue"
export default component.exports